'use strict';
module.exports = require('../../full/instance/sort');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/sort.js
// module id = 601
// module chunks = 13